(() => {
  const sections = document.querySelectorAll('[data-whyshift-membership-faq]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const search = section.querySelector('[data-whyshift-faq-search]');
    const items = section.querySelectorAll('[data-whyshift-faq-item]');
    const empty = section.querySelector('[data-whyshift-faq-empty]');
    if (!search || !items.length) return;

    const filter = () => {
      const query = search.value.trim().toLowerCase();
      let visible = 0;

      items.forEach((item) => {
        const text = (item.getAttribute('data-search-text') || item.textContent || '').toLowerCase();
        const match = !query || text.includes(query);
        item.hidden = !match;
        if (match) visible += 1;
      });

      if (empty) {
        empty.hidden = visible > 0 || !query;
      }
    };

    search.addEventListener('input', filter);
  });
})();
